import Accordion from 'react-bootstrap/Accordion';
import styled from 'styled-components';
import { resources } from '../TempData';
import MyWorkContanier from './MyWorkContainer';
import { useNavigate } from 'react-router-dom';

const AccordionWrapper = styled.div`
    padding:10px 150px;
    margin-top:40px;
    .accordion-item{
        border:2px solid gray;
        margin-bottom:15px;
    }
    .accordion{
        --bs-accordion-bg: transparent !important;
        border: none !important;
        color:white !important;
    }
    .accordion-header{
        margin-bottom:1px;
        button{
            color:white !important;
        }
    }
    .accordion, .accordion-body{
        --bs-accordion-transition: color 0.5s ease-in-out,background-color 0.5s ease-in-out,border-color 0.5s ease-in-out,box-shadow 0.5s ease-in-out,border-radius 0.5s ease;
    }

    .accordion-collapse .collapse, .show, .accordion-body{
        &:active, &:focus{
            border:0px !important;
        }
    }
    .accordion-button:not(.collapsed){
        background-color: var(--border) !important;
        color:var(--black) !important;
        border-bottom:2px solid gray;
        &:active{
            outline: none !important;
        }
    }
    .accordion-body{
        background-color: var(--border) !important;
        color:var(--black) !important;
    }

    .accordion-button{
        color: black !important;
        border: 0px !important;
        outline: none !important;
    }

    .accordion-item:first-of-type .accordion-button {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }

    .accordion-button:focus {
        z-index: 3 !important;
        outline: 0 !important;
        box-shadow: none !important;
    }
    @media screen and (max-width: 768px){
        padding:10px 30px;
    }
`

const AccordionBodyContainer = styled.div`
    
    .center{
        display: flex;
        justify-content: center;
        align-items: center;
        padding:20px 50px;
        background-color:var(--border) !important;
        h6{
            background-color:var(--border) !important;
            color:var(--black);
            font-size:17px;
            font-weight:500;    
        }
    }
`


function AccordionComponent() {
    const navigate = useNavigate()
    return (
        <AccordionWrapper>
            <Accordion>
                {resources.map((item, index) => (
                    <Accordion.Item key={item.id} eventKey={index} >
                        <Accordion.Header >{item.name}</Accordion.Header>
                        <Accordion.Body style={{ color: 'white' }}>
                            <AccordionBodyContainer>
                                <div className='center'>
                                    <h6>{item.description}</h6>
                                </div>
                                {item?.content?.map((content, count) => (
                                    <MyWorkContanier key={count} onClick={()=>navigate('/WebShop')} showButton={true} resourcesFlag={true} title={content[`contentTitle${count + 1}`]} desc={content[`contentDescription${count + 1}`]} image={content[`image${count+1}`]} imageLast={count % 2 === 0} />
                                ))}
                            </AccordionBodyContainer>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </AccordionWrapper>
    );
}

export default AccordionComponent